export default __webpack_public_path__ + "static/media/N2P_1900.6c8e6f23.jpg";